import { Box, Divider, Stack } from "@mui/material";
import EmbraceLogo from "../Common/EmbraceLogo";
import { useAppSelector } from "../../Redux/hooks";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

const ScreeningParticipantLayout = ({ children }: Props) => {
  const backgroundColor = useAppSelector((state) => state.study.backgroundColor);

  return (
    <Stack
      sx={{
        height: "100vh",
        width: "100%",
        flexDirection: "column",
        backgroundColor: backgroundColor || "grey.50",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "70px",
          px: 3,
          py: 2,
          border: { xs: "1px solid #E5E7EB", md: "none" },
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
        }}
      >
        <EmbraceLogo sx={{ height: { xs: 40, md: 44 } }} />
      </Box>
      <Divider />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
          py: 4,
          overflow: "auto",
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default ScreeningParticipantLayout;
